import { render } from "./LotteryTit.vue?vue&type=template&id=2daa47f4&scoped=true&bindings={}"
import script from "./LotteryTit.vue?vue&type=script&lang=ts"
export * from "./LotteryTit.vue?vue&type=script&lang=ts"

import "./LotteryTit.vue?vue&type=style&index=0&id=2daa47f4&scoped=true&lang=less"
script.render = render
script.__scopeId = "data-v-2daa47f4"

export default script